"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authTokenContract = void 0;
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("../winner/models");
const models_2 = require("./models");
const c = (0, core_1.initContract)();
exports.authTokenContract = c.router({
    redeemWithToken: {
        method: 'POST',
        path: '/token-redemption-option/:id/redeem',
        pathParams: zod_1.z.object({
            id: zod_1.z.coerce.number(),
        }),
        body: zod_1.z.object({
            [models_2.TokenRedemptionOptionTypeEnum.PRIZE]: zod_1.z
                .object({
                prizeId: zod_1.z.coerce.number(),
                productId: zod_1.z.coerce.number().optional(),
            })
                .merge(models_1.ZPrizeOrderInsert.pick({
                deliveryStreet: true,
                deliveryCity: true,
                deliveryPostcode: true,
                emailAddress: true,
                phoneNumber: true,
                additionalInfoFromPlayer: true,
            }))
                .optional(),
            [models_2.TokenRedemptionOptionTypeEnum.ENTRY]: zod_1.z
                .object({
                entries: dbJsonModels_1.ZEntryLine.array(),
                drawId: zod_1.z.coerce.number().optional(),
            })
                .optional(),
            [models_2.TokenRedemptionOptionTypeEnum.TREE]: zod_1.z
                .object({
                quantity: zod_1.z.coerce.number().optional(),
            })
                .optional(),
        }),
        responses: {
            200: zod_1.z.object({
                id: zod_1.z.string(),
            }),
            400: zod_1.z.object({
                message: zod_1.z.string(),
                reason: zod_1.z.string().optional(),
            }),
        },
    },
    getTokenRedemptionOrder: {
        method: 'GET',
        path: '/token-redemption/:id',
        responses: {
            200: zod_1.z.array(models_2.ZTokenRedemptionOrder),
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
    purchaseTokens: {
        method: 'POST',
        path: '/purchase-tokens',
        body: zod_1.z.object({
            tokenAmount: zod_1.z.number(),
            expectedCost: zod_1.z.number(),
            sourceFor3DS: zod_1.z.string().optional(),
        }),
        responses: {
            200: models_2.ZPurchaseTokensResponse,
            400: zod_1.z.object({
                message: zod_1.z.string(),
                reason: zod_1.z
                    .union([
                    zod_1.z.literal('ACCOUNT_SUSPENDED'),
                    zod_1.z.literal('WOULD_EXCEED_SPEND_LIMIT'),
                ])
                    .optional(),
                spendLimitPence: zod_1.z.number().optional(),
            }),
        },
    },
    getTokenBalanceForUser: {
        method: 'GET',
        path: '/token-balance',
        responses: {
            200: zod_1.z.number(),
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
}, {
    pathPrefix: '/auth',
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=token.auth.contract.js.map